import { useSelector } from 'react-redux';
import {
    getCreateGroupRequest,
    getProductsSourceSetModel,
    getSelectedGroup,
    getUpdateGroupRequest,
    isManagementInEditMode,
    isUserSettingsEditMode,
} from '.';

export const useUserSettingsEditMode = () =>
    useSelector(isUserSettingsEditMode);
export const useManagementEditMode = () => useSelector(isManagementInEditMode);
export const useSelectedGroup = () => useSelector(getSelectedGroup);

export const useCreateGroupRequest = () => useSelector(getCreateGroupRequest);
export const useUpdateGroupRequest = () => useSelector(getUpdateGroupRequest);
export const useProductsSourceSetModel = () =>
    useSelector(getProductsSourceSetModel);
